import { useState } from "react";
import { BadgeCheck, MailWarning } from "lucide-react";
import { toast } from "sonner";
import { Field, FormError, SubmitButton } from "./Field";
import { useAccount } from "@/context/AccountContext";
import { accountApi, errorMessage } from "@/lib/api";

export const Card = ({ title, index, testid, children }) => (
  <section data-testid={testid} className="border border-line bg-ink-2 p-6 sm:p-8">
    <p className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.3em] text-smoke">
      <span className="text-acid">({index})</span> {title}
    </p>
    <div className="mt-6">{children}</div>
  </section>
);

export const useSaveProfile = () => {
  const { customer, setCustomer } = useAccount();
  return async (patch) => {
    const { data } = await accountApi.put("/account/me", { name: customer.name, shipping_address: customer.shipping_address, ...patch });
    setCustomer(data);
  };
};

export const ProfileCard = () => {
  const { customer } = useAccount();
  const save = useSaveProfile();
  const [name, setName] = useState(customer.name);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await save({ name });
      toast.success("Dati aggiornati");
    } catch (err) {
      setError(errorMessage(err, "Inserisci un nome valido (almeno 2 caratteri)."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card title="I tuoi dati" index="01" testid="account-profile-card">
      <form onSubmit={submit} className="space-y-6">
        <Field label="Nome e cognome" required minLength={2} value={name} onChange={(e) => setName(e.target.value)} testid="account-name-input" />
        <div>
          <Field label="Email" value={customer.email} readOnly testid="account-email-display" />
          <p className={`mt-2 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] ${customer.email_verified ? "text-acid" : "text-amber-300"}`} data-testid="account-email-status">
            {customer.email_verified ? <BadgeCheck className="h-3.5 w-3.5" /> : <MailWarning className="h-3.5 w-3.5" />}
            {customer.email_verified ? "Email confermata" : "Email da confermare"}
          </p>
        </div>
        <FormError error={error} testid="account-profile-error" />
        <SubmitButton loading={loading} testid="account-profile-save-button" loadingText="Salvo…">Salva dati</SubmitButton>
      </form>
    </Card>
  );
};
